var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ChartCard',{ref:"target",attrs:{"title":"Top Event Referrals","is-loading":_vm.isLoading,"timestamp":_vm.allData ? _vm.allData.timestamp : null,"padding-bottom":false}},[_c('ReferralsTable',{attrs:{"type":"events","is-loading":_vm.isLoading,"data":_vm.data,"all-data":_vm.allData}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }